const SectionTitle = ({ title }: { title: string }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="section-title-container"
    >
      <h2>{title}</h2>
      <h1
        style={{
          position: "absolute",
          color: "#333333",
          zIndex: -100,
        }}
      >
        {title}
      </h1>
    </div>
  );
};

export default SectionTitle;
